/**
 * 
 * @param {Number} number 
 */
export function isEven(value){
    return (typeof value === 'number') && (value % 2 === 0) ? true : false;
}

/**
 * Convert a number to string and return with a space after thousand
 * @param {Number} number
 * @returns {String}
 */
export function addThousandSeparationToNumber(number) {  
    if(number.toString().length > 3) {
        let formatedNumber = number.toString()
                                .split('');

        formatedNumber.splice(number.toString().length - 3, 0, ' ')
                    
       return formatedNumber.join('');
    }

    return number
}